import _ from 'lodash';
import { gEnums } from '../../enums/globalEnums';
import { setStyleAndClass } from '../../styles/formatting';
import { dataFix } from '../../common/dataFix';
import { _appSettingsOriginTypes, _settingSourceTypes } from '../../cnr/contexts/ServiceWorkerContext';

const _appUserStuff = [
  'appUserDataModifications',
  'appUserDataSettings',
  'appUserImageOptions',
  'appUserAuth',
  'appUserPagePermissions',
  'appUserPermissions',
  'appUserProfileInfo',
  'appUserSettings',
  'appUserUiOptions',
]

/** Get the settings for the page */
export const getSettingsAreaProps = (props) => {

  const { pathViews, lastView, hceStates } = props

  const { homeSettings_state, clientSettings_state, eventSettings_state } = hceStates ?? {}

  let settings_currentArea;
  let settingsSourceType = 'normal';

  if (pathViews) {
    if (pathViews.events || lastView === 'events') {
      settings_currentArea = eventSettings_state ? eventSettings_state.eventSettings : {}
      settingsSourceType = eventSettings_state?.eventSettings?.settingsSourceType || 'normal'
    } else if (pathViews.clients || lastView === 'clients') {
      settings_currentArea = clientSettings_state ? clientSettings_state.clientSettings : {}
    } else {
      settings_currentArea = homeSettings_state ? homeSettings_state.homeSettings : {}
    }
  }

  return {
    settings_currentArea,
    time_stamp: settings_currentArea ? settings_currentArea.time_stamp : null,
    tss: Date.now(),
    settingsSourceType
  }
}

const ammendPageViewItems = (viewItems) => {
  if (viewItems) {
    Object.keys(viewItems).forEach(viKey => {
      if (!viewItems[viKey].key) {
        if (_.isObject(viewItems[viKey])) {
          viewItems[viKey].key = viKey
        }
      }
    })
  }
  return viewItems
}


/**
 * Returns 
 * @param {object} aspProps 
 * @returns the current settings for the page
 */
export const getAreaSettingsProps = (aspProps) => {

  let _settingsSourceType;

  const {
    // setPageSettings,
    appDataSource,
    pageKey,
    demo_state,
    preview_state,
    settingsAreaProps,
    settingsPreviewOn,
    tempDataSource,
    trueView,
    view,
  } = aspProps

  const { settingsPreviewHasChanged, settings_preview, settings_googleSheets } = preview_state ?? {}

  const { settings_currentArea } = settingsAreaProps ?? {}

  const {
    global,
    isGlobalStatic,
    isViewStatic,
    missingSettings,
    settingsDocName,
    settingsSourceType,
    status,
    viewItems: pageItems,
    views,
  } = settings_currentArea ?? {}

  _settingsSourceType = settingsSourceType

  const pageView = views ? views[trueView] : {}
  const { viewItems: viewItems_page } = pageView ?? {}

  const _aps_appUserSettings = {}

  if (global) {
    _.forEach(global, (value, key) => {
      if (_appUserStuff.includes(key) && value) {
        _.assign(_aps_appUserSettings, value);
      }
    });
  }

  ammendPageViewItems(viewItems_page)

  let aps_page = dataFix.removeNumericKeys(pageView)

  if (aps_page?.viewItems) {
    _.forEach(aps_page.viewItems, (value) => {
      if (_.isObject(value)) {
        _.set(value, '_viewPermissionType', 'allow');
      }
    });
  }

  // set the caption if none exists
  if (aps_page && _.isObject(aps_page) && !aps_page.menu) {
    const isList = trueView && trueView.indexOf('_list') >= 0
    const _props = !isList && aps_page && aps_page.viewItems && aps_page.viewItems[view] && aps_page.viewItems[view].props
    const { firstName, lastName } = _props ?? {}
    const _captionProps = firstName && lastName ? ['firstName', 'lastName'] : ['name']
    aps_page.menu = {
      captionType: isList ? gEnums.captionTypes.fixed : gEnums.captionTypes.fromData,
      caption: _.startCase(view),
      captionProps: !isList ? _captionProps : null
    }
  }

  const { useAppUsersAsAppUser } = _aps_appUserSettings ?? {}

  if (useAppUsersAsAppUser) {
    _aps_appUserSettings.appUserCollection = 'appUsers'
    _aps_appUserSettings.appUserCollections = ['appUsers']
  }

  const appSettings = {
    aps_page,
    _appSettingsOriginType: _appSettingsOriginTypes.settings,
  }

  if (settingsPreviewOn && settingsPreviewHasChanged && settings_preview) {
    const { page } = settings_preview ?? {}
    appSettings.aps_page = page
    appSettings._appSettingsOriginType = _appSettingsOriginTypes.preview
  }

  const { appDataSourceType } = appDataSource ?? {}

  const _adst = tempDataSource ? tempDataSource : appDataSourceType

  switch (_adst) {
    case gEnums.dataSourceTypes.googleSheet:
      if (settings_googleSheets) {
        const { views } = settings_googleSheets ?? {}
        const _page = views && trueView && views[trueView] ? views[trueView] : {}
        appSettings.aps_page = _page
        appSettings._appSettingsOriginType = _appSettingsOriginTypes.googleSheets
      }
  }

  if (demo_state && demo_state?.demoOn) {
    const { demoPreview } = demo_state ?? {}
    const { projectSettings } = demoPreview ?? {}
    const { views } = projectSettings ?? {}
    const _page = views && trueView && views[trueView] ? views[trueView] : {}
    appSettings.aps_page = _page
    appSettings._appSettingsOriginType = _appSettingsOriginTypes.demo
  }

  if (appSettings.aps_global) {
    appSettings.aps_styles = _.mapValues(gEnums.projectStyles, (_, psKey) =>
      setStyleAndClass(appSettings.aps_global, psKey)
    );
  }

  const _appSettings = appSettings

  const ps = {
    settingsDocName,
    ..._appSettings,
    isGlobalStatic,
    isViewStatic,
    pageSettingsKey: pageKey,
    missingSettings,
    status,
    settingsSourceType
  }

  return ps

}